import '../App.scss';
import { useState, useEffect } from 'react';

// Theme imports
import { Container, Input } from '@material-ui/core';
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
} from '@material-ui/core';

import axios from 'axios';
import dayjs from 'dayjs';

// Helpers imports
import CountryList from '../helpers/countries';
import { prefixes, extendedPrefixes, presences } from '../helpers/formoptions';
// Form imports
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const StatementForm = () => {
  const validationSchema = Yup.object().shape({
    organisation: Yup.boolean(),
    country: Yup.string().when('organisation', {
      is: false,
      then: Yup.string().required('Country is required'),
    }),
    administration: Yup.string().when('organisation', {
      is: false,
      then: Yup.string().required('Administration is required'),
    }),
    organisation_name: Yup.string().when('organisation', {
      is: true,
      then: Yup.string().required('Organisation name is required'),
    }),
    prefix: Yup.string().required('Prefix is required'),
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    title: Yup.string().required('Title is required'),
    preferred_slot: Yup.string().required('Preferred slot is required'),
    second_choice: Yup.string().required('Second choice is required'),
    third_choice: Yup.string().required('Third choice is required'),
    participation: Yup.string().required('Participation is required'),
    contact_prefix: Yup.string().required('Contact prefix is required'),
    contact_first_name: Yup.string().required('Contact first name is required'),
    contact_last_name: Yup.string().required('Contact last name is required'),
    contact_title: Yup.string().required('Contact title is required'),
    contact_email: Yup.string()
      .email('Invalid email address')
      .required('Contact email is required'),
    repeat_email: Yup.mixed().test('match', 'Emails do not match', function () {
      return this.parent.contact_email === this.parent.repeat_email;
    }),
    contact_phone: Yup.string().required('Contact phone is required'),
  });
  const {
    getValues,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [organisation, setOrganisation] = useState(false);
  const [statementSlots, setStatementSlots] = useState([]);
  const [savingState, setSavingState] = useState('idle');

  const checkIfSelected = (date) => {
    return watch('preferred_slot') === date ||
      watch('second_choice') === date ||
      watch('third_choice') === date
      ? true
      : false;
  };

  const checkSavingState = () => {
    return savingState === 'saving' ? true : false;
  };
  const checkSavedState = () => {
    return savingState === 'saved' ? true : false;
  };

  const reactAppData = window.itu_slot_form || {
    appSelector: '#root',
  };
  const { ajax_url } = reactAppData;

  useEffect(() => {
    const getSlots = async () => {
      const ajaxendpoint = ajax_url
        ? ajax_url + 'policy_slots'
        : 'https://itu-gutemberg.dev/wtpf21/wp-json/itu-wp-api/v1/policy_slots';

      const availslots = await axios.get(ajaxendpoint);
      setStatementSlots(availslots.data);
    };
    getSlots();
  }, [ajax_url]);

  const onSubmit = async (data) => {
    setSavingState('saving');
    const ajaxendpoint = ajax_url
      ? ajax_url + 'policy_statements'
      : 'https://itu-gutemberg.dev/wtpf21/itu-wp-api/v1/policy_statements';
    const sendData = async () => {
      const response = await axios.post(ajaxendpoint, { edit: false, data });
      setSavingState('saved');
      return response.data;
    };
    await sendData();
  };
  return (
    <>
      {!checkSavedState() && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <input type="hidden" name="category" value="category" />
          <div className="App">
            <Container maxWidth={false}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <h4 color="primary">
                    Please note that all fields are mandatory
                  </h4>
                </Grid>
                {/* Organisation switch */}
                <Grid item xs={12}>
                  <h3>Administration</h3>
                  <Input
                    type="hidden"
                    name="organisation"
                    value={organisation}
                  />
                  {/* <FormControlLabel
                    control={
                      <Controller
                        control={control}
                        name="organisation"
                        defaultValue={false}
                        render={({ field: { onChange, ref } }) => (
                          <Switch
                            disabled={checkSavingState()}
                            onChange={(e) => {
                              onChange(e);
                              setOrganisation(!organisation);
                            }}
                            inputRef={ref}
                            color="primary"
                          />
                        )}
                      />
                    }
                    label="I am an organisation"
                  /> */}
                </Grid>
                {!getValues('organisation') ? (
                  <>
                    {/* If not organisation, country and administration */}
                    <Grid item xs={6}>
                      <FormControl>
                        <InputLabel>Country</InputLabel>
                        <Controller
                          control={control}
                          name="country"
                          id="country"
                          render={({ field: { onChange, value = '' } }) => (
                            <Select
                              variant="filled"
                              autoComplete="false"
                              onChange={onChange}
                              value={value}
                              disabled={checkSavingState()}
                            >
                              {CountryList.map((c, i) => {
                                return (
                                  <MenuItem key={i} value={c.Code}>
                                    {c.Code}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          )}
                        />
                      </FormControl>
                      <p className="invalid-data">{errors.country?.message}</p>
                    </Grid>

                    <Grid item xs={6}>
                      <Controller
                        control={control}
                        name="administration"
                        id="administration"
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="Administration"
                            variant="filled"
                            fullWidth
                            autoComplete="false"
                            onChange={onChange}
                            value={value}
                            disabled={checkSavingState()}
                          />
                        )}
                      />
                      <p className="invalid-data">
                        {errors.administration?.message}
                      </p>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12}>
                    {/* If organisation, organisation name */}
                    <Controller
                      control={control}
                      name="organisation_name"
                      id="organisation_name"
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="Organisation"
                          variant="filled"
                          fullWidth
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        />
                      )}
                    />
                    <p className="invalid-data">
                      {errors.organisation_name?.message}
                    </p>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <div className="separator"></div>
                </Grid>
                {/* Prefix */}
                <Grid item xs={12}>
                  <h3>Speaker information</h3>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <InputLabel>Prefix</InputLabel>
                    <Controller
                      control={control}
                      name="prefix"
                      id="prefix"
                      render={({ field: { onChange, value = '' } }) => (
                        <Select
                          variant="filled"
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        >
                          {extendedPrefixes.map((c, i) => {
                            return (
                              <MenuItem key={i} value={c.value}>
                                {c.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="invalid-data">{errors.prefix?.message}</p>
                </Grid>
                {/* Last name */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="last_name"
                    id="last_name"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Last Name"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">{errors.last_name?.message}</p>
                </Grid>
                {/* First name */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="first_name"
                    id="first_name"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="First Name"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">{errors.first_name?.message}</p>
                </Grid>
                {/* Title */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="title"
                    id="title"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Title"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">{errors.title?.message}</p>
                </Grid>
                <Grid item xs={12}>
                  <div className="separator"></div>
                </Grid>
                {/* Slots */}
                {/* Preferred slot */}
                <Grid item xs={12}>
                  <h3>Preferred policy statement slots</h3>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <InputLabel>Preferred slot</InputLabel>
                    <Controller
                      control={control}
                      name="preferred_slot"
                      id="preferred_slot"
                      render={({ field: { onChange, value = '' } }) => (
                        <Select
                          variant="filled"
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        >
                          {statementSlots?.length > 0
                            ? statementSlots.map((c, i) => {
                                const formattedDate =
                                  new dayjs(c.formattedDate).format(
                                    'dddd, MMMM D YYYY '
                                  ) + c.halfday;
                                const valueDate =
                                  new dayjs(c.formattedDate).format(
                                    'DD-MM-YYYY '
                                  ) + c.halfday;
                                return (
                                  <MenuItem
                                    key={i}
                                    value={valueDate}
                                    disabled={checkIfSelected(valueDate)}
                                  >
                                    {formattedDate}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="invalid-data">
                    {errors.preferred_slot?.message}
                  </p>
                </Grid>
                {/* Second choice slot */}
                <Grid item xs={6}>
                  <FormControl>
                    <InputLabel>Second choice</InputLabel>
                    <Controller
                      control={control}
                      name="second_choice"
                      id="second_choice"
                      render={({ field: { onChange, value = '' } }) => (
                        <Select
                          variant="filled"
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        >
                          {statementSlots?.length > 0
                            ? statementSlots?.map((c, i) => {
                                const formattedDate =
                                  new dayjs(c.formattedDate).format(
                                    'dddd, MMMM D YYYY '
                                  ) + c.halfday;
                                const valueDate =
                                  new dayjs(c.formattedDate).format(
                                    'DD-MM-YYYY '
                                  ) + c.halfday;
                                return (
                                  <MenuItem
                                    key={i}
                                    value={valueDate}
                                    disabled={checkIfSelected(valueDate)}
                                  >
                                    {formattedDate}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="invalid-data">
                    {errors.second_choice?.message}
                  </p>
                </Grid>
                {/* Third choice */}
                <Grid item xs={6}>
                  <FormControl>
                    <InputLabel>Third choice</InputLabel>
                    <Controller
                      control={control}
                      name="third_choice"
                      id="third_choice"
                      render={({ field: { onChange, value = '' } }) => (
                        <Select
                          variant="filled"
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        >
                          {statementSlots?.length > 0
                            ? statementSlots?.map((c, i) => {
                                const formattedDate =
                                  new dayjs(c.formattedDate).format(
                                    'dddd, MMMM D YYYY '
                                  ) + c.halfday;
                                const valueDate =
                                  new dayjs(c.formattedDate).format(
                                    'DD-MM-YYYY '
                                  ) + c.halfday;
                                return (
                                  <MenuItem
                                    key={i}
                                    value={valueDate}
                                    disabled={checkIfSelected(valueDate)}
                                  >
                                    {formattedDate}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="invalid-data">{errors.third_choice?.message}</p>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <InputLabel>Participation</InputLabel>
                    <Controller
                      control={control}
                      name="participation"
                      id="participation"
                      render={({ field: { onChange, value = '' } }) => (
                        <Select
                          variant="filled"
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        >
                          {presences.map((c, i) => {
                            return (
                              <MenuItem key={i} value={c.value}>
                                {c.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="invalid-data">
                    {errors.participation?.message}
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <div className="separator"></div>
                </Grid>
                {/* Contact info */}
                {/* Contact Prefix */}
                <Grid item xs={12}>
                  <h3>Contact information</h3>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <InputLabel>Contact prefix</InputLabel>
                    <Controller
                      control={control}
                      name="contact_prefix"
                      id="contact_prefix"
                      render={({ field: { onChange, value = '' } }) => (
                        <Select
                          variant="filled"
                          autoComplete="false"
                          onChange={onChange}
                          value={value}
                          disabled={checkSavingState()}
                        >
                          {prefixes.map((c, i) => {
                            return (
                              <MenuItem key={i} value={c.value}>
                                {c.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="invalid-data">
                    {errors.contact_prefix?.message}
                  </p>
                </Grid>
                {/* Contact last name */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="contact_last_name"
                    id="contact_last_name"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Contact Last Name"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">
                    {errors.contact_last_name?.message}
                  </p>
                </Grid>
                {/* Contact first name */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="contact_first_name"
                    id="contact_first_name"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Contact First Name"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">
                    {errors.contact_first_name?.message}
                  </p>
                </Grid>
                {/* Contact title */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="contact_title"
                    id="contact_title"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Contact Title"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">
                    {errors.contact_title?.message}
                  </p>
                </Grid>
                {/* Contact email */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="contact_email"
                    id="contact_email"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Contact Email"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">
                    {errors.contact_email?.message}
                  </p>
                </Grid>
                {/* Contact repeat email */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="repeat_email"
                    id="repeat_email"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Repeat Contact Email"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">{errors.repeat_email?.message}</p>
                </Grid>
                {/* Contact phone */}
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="contact_phone"
                    id="contact_phone"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Contact Phone"
                        variant="filled"
                        fullWidth
                        autoComplete="false"
                        onChange={onChange}
                        value={value}
                        disabled={checkSavingState()}
                      />
                    )}
                  />
                  <p className="invalid-data">
                    {errors.contact_phone?.message}
                  </p>
                </Grid>
                {/* Submit */}
                <Grid item xs={12}>
                  {!checkSavingState() ? (
                    <Button type="submit" variant="contained" color="primary">
                      Submit request
                    </Button>
                  ) : (
                    <div className="ituContainer grid">
                      <div className="ituCard highlight" data-span="8">
                        <div className="content">
                          <div className="main">
                            <p classname="title">
                              <strong>
                                Sending your request, please wait...
                              </strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Container>
          </div>
        </form>
      )}
      {checkSavedState() && (
        <div className="ituContainer grid">
          <div className="ituCard highlight" data-span="8">
            <div className="content">
              <div className="main">
                <p classname="title">
                  <strong>
                    Thank you for your request! A confirmation email has been
                    sent to your email address.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StatementForm;
